<template>
  <el-dialog
    title="Relatórios de Imóveis - Venda"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="46%"
  >
    <el-form
      :model="relatorio"
      ref="form"
      size="small"
      label-position="top"
      hide-required-asterisk
      :show-message="false"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Relatório">
            <el-select
              auto-complete="off"
              v-model="relatorio.nome"
              clearable
              placeholder
              style="width: 100%;"
            >
              <el-option
                v-for="item in tiposRelatorios"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" style="padding: 10px 0px 10px 0px">
        <el-col :span="24">
          <el-radio v-model="relatorio.xls" :label="false">PDF</el-radio>
          <el-radio v-model="relatorio.xls" :label="true">Excel</el-radio>
        </el-col>
      </el-row>

      <p/>

      <el-row :gutter="24" v-if="exibirCampoCaptacao">
        <el-col :span="8">
          <el-checkbox v-model="filtroDataCaptacao">Filtrar pela data de captação</el-checkbox>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirFiltroDataPlaca">
        <el-col :span="16" :md="24">
          <el-form-item label="Pesquisar por Data de:" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.dataPlaca" style="font-size: small;">
              <el-radio label="CAPTACAO" style="margin-top:5px">Captação do Imóvel</el-radio>
              <el-radio label="COLOCACAO" style="margin-top:5px" v-if="exibirDataColocacaoPlaca">Instalação da Placa</el-radio>
              <el-radio label="RETIRADA" style="margin-top:5px" v-if="exibirDataColocacaoPlaca">Retirada da Placa</el-radio>
              <el-radio label="SEM_FILTRO" style="margin-top:5px">Não Filtrar</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <p/>

      <span v-if="exibirCampoPeriodo">Período</span>
      <el-row v-if="exibirCampoPeriodo" :gutter="24">
        <el-col :span="12">
          <el-form-item prop="dataInicial">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"  
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="dataFinal">
            <el-date-picker
              v-model="relatorio.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <p/>

      <el-row v-if="exibirCamposCaptados" :gutter="24">
        <el-col :span="24">
          <el-form-item label="Tipo do Imóvel">
            <el-select
              auto-complete="off"
              v-model="relatorio.imovel.tipoImovel"
              value-key="id"
              clearable
              @clear="relatorio.imovel.tipoImovel = undefined"
              placeholder
              style="width: 100%;"
            >
              <el-option
                v-for="item in tiposImoveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <p/>

      <el-row v-if="exibirCamposVendidos" :gutter="10" style="padding: 0px 0px;">
        <el-col :span="19">
          <el-form-item label="Atendentes">
            <el-select
              v-model="auxUsuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              @focus="filtrarUsuariosSelect"
              value-key="id"
              placeholder
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              clearable
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item label=" " style="width: 100%">
            <el-button
              @click.native.prevent="adicionarUsuarioSelecionado()"
              type="success"
              size="small"
              style="width: 100%"
              round
              class="btn-box-shadow"
            >Adicionar</el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="exibirCamposVendidos" style="height: 40%; padding: 10px 0px;">
        <el-col :span="24" style="height: 100%">
          <el-container style="height: 100%">
            <el-main style="padding: 0px; height: 100%">
              <el-table
                :data="usuariosSelecionados"
                empty-text="Nenhum usuario selecionado"
                width="100%"
                max-height="250"
                size="small"
                style="background-color: #FFFFFF; border: solid 1px #DBDFE5; border-radius: 5px;"
                stripe
                highlight-current-row
              >
                <el-table-column label="Nome" width="250" prop="nome"/>
                <el-table-column width="250">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="removerUsuarioSelecionado(scope.row)"
                      type="text"
                      size="small"
                      style="padding: 0px; color: #F56C6C;"
                    >Remover</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="exibirCampoCliente">
        <el-col :span="24">
          <el-form-item label="Cliente" style="width: 100%">
            <el-select
              v-model="relatorio.cliente"
              :remote-method="filtrarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder
              loading-text="Carregando clientes"
              no-data-text="Nenhum cliente encontrado"
              filterable
              clearable
              @clear="relatorio.cliente = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in clientesDisponiveis"
                :key="item.id"
                :label="formatarSelectCliente(item)"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="exibirCamposVendidos" :gutter="24">
        <el-col :span="24">
          <el-form-item label="Perfil">
            <el-select
              auto-complete="off"
              v-model="relatorio.usuario.perfil"
              clearable
              @clear="relatorio.usuario.perfil = undefined"
              placeholder
              style="width: 100%;"
            >
              <el-option
                v-for="item in tiposPerfis"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <p/>

      <el-row v-if="exibirCampoCorretor" :gutter="24">
        <el-col :span="24">
          <el-form-item label="Corretor">
            <el-select
              v-model="relatorio.usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              @focus="filtrarUsuariosSelect"
              value-key="id"
              placeholder
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              clearable
              @clear="relatorio.usuario = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="exibirCampoImovel" :gutter="20">
        <el-col :span="24">
          <el-form-item label="Imóvel" prop="imovel">
            <el-select
              v-model="relatorio.imovel"
              :remote-method="filtrarImoveisSelect"
              :loading="loadingImoveis"
              value-key="id"
              placeholder
              loading-text="Carregando imoveis"
              no-data-text="Nenhum imóvel encontrado"
              filterable
              clearable
              @clear="limparImovelSelecionado"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in imoveisDisponiveis"
                :key="item.id"
                :label="formatarEnderecoImovel(item)"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <span v-if="exibirStatusPlaca" style="font-weight: bold;">Status da Placa</span>
      <el-row :gutter="24" v-if="exibirStatusPlaca">
        <el-col :span="24" style="display: block;">
            <el-checkbox v-model="selecionarTodosPlacas" @change="alterarStatusTodosPlacas">Todos</el-checkbox>
            <el-checkbox-group v-model="relatorio.statusSelecionadosPlaca" style="display: grid; grid-template-columns: repeat(4, auto); gap: 5px 5px; align-items: center;">              
              <el-checkbox v-for="item in opcoesStatusPlacas" 
              :key="item.data"
              :label="item.data"
              >
              {{item.label}}
              </el-checkbox>
            </el-checkbox-group>
        </el-col>
      </el-row>

      <p/>

      <span v-if="exibirCampoTipo" style="font-weight: bold;">Status</span>
      <el-row :gutter="24" v-if="exibirCampoTipo">
        <el-col :span="8" style="display: block;">
            <el-checkbox v-model="selecionarTodos" @change="alterarStatusTodos">Todos</el-checkbox>
            <el-checkbox-group v-model="relatorio.statusSelecionadosImovel">
              <el-checkbox v-for="item in opcoesStatusImoveis" 
              :key="item.data"
              :label="item.data"
              >
              {{item.label}}
              </el-checkbox>
            </el-checkbox-group>
        </el-col>

      </el-row>
    </el-form>
    
    <span slot="footer">
      <el-button type="primary" size="small" @click="gerar()" round class="btn-box-shadow">Gerar Relatório</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

import funcoes from "../../../util/funcoes.js";
import { TIPOS_IMOVEIS } from "../../../util/constantes.js";

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      tiposRelatorios: [
        {
          value: "IMOVEIS_CAPTACAO_TIPO_IMOVEL",
          label: "Imóveis Captados"
        },
        { 
          label: "Ficha de Imóvel", 
          value: "IMOVEIS_FICHA" 
        },
        {
          value: "IMOVEIS_VENDIDOS",
          label: "Imóveis Vendidos"
        },
        {
          value: "IMOVEIS_POR_CLIENTE",
          label: "Imóveis por Cliente"
        },
        {
          value: "IMOVEIS_COM_PLACA",
          label: "Imóveis Com Placa"
        },
        {
          value: "IMOVEIS_SEM_PLACA",
          label: "Imóveis Sem Placa"
        },
        {
          value: "IMOVEIS_SEM_FOTO",
          label: "Imóveis Sem Foto"
        },
        {
          value: "IMOVEIS_RESERVADOS",
          label: "Imóveis Reservados"
        },
        {
          value: 'IMOVEIS_PUBLICADOS_SITE',
          label: 'Imóveis Publicados no Site'
        },
        {
          value: 'IMOVEIS_ACOMPANHAMENTO',
          label: 'Imóveis com E-mail de Acompanhamento'
        },
        {
          value: "OBSERVACOES_POR_PERIODO",
          label: "Observações por Período"
        },
        {
          value: "VISITAS_POR_PERIODO",
          label: "Visitas por Período"
        }
      ],
      tiposPerfis: [
        {
          value: "ADMINISTRADOR",
          label: "Administrador"
        },
        {
          value: "GERENTE",
          label: "Gerente"
        },
        {
          value: "CORRETOR",
          label: "Corretor"
        },
        {
          value: "SECRETARIO",
          label: "Secretário"
        },
        {
          value: "PARCEIRO",
          label: "Parceiro"
        }
      ],
      opcoesStatusImoveis: [
        {label: "Disponível", data: "DISPONIVEL"},
        {label: "Indisponível", data: "INDISPONIVEL"},
        {label: "Vendido", data: "VENDIDO"},        
        {label: "Arquivado", data: "ARQUIVADO"},
      ],
      selecionarTodos: false,
      relatorio: {
        nome: undefined,
        usuario: {
          perfil: undefined
        },
        xls: false,
        modulo: 'VENDA',
        statusSelecionadosImovel: ['DISPONIVEL'],
        imovel: {
          operacao: "VENDA",
          tipoImovel: undefined
        },
        cliente: undefined,
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        idsCorretores: "",
        dataPlaca: 'CAPTACAO',
        statusSelecionadosPlaca: ['COLOCADA']
      },

      selecionarTodosPlacas: false,
      filtroDataCaptacao: true,
      loadingUsuarios: false,
      loadingClientes: false,
      loadingImoveis: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      auxUsuario: {},
      usuariosSelecionados: []
    };
  },
  computed: {
    ...mapState("vendasRelatoriosStore", {
      usuariosDisponiveis(state) {
        const usuarios = state.usuariosDisponiveis;

        const porUsuariosQueAindaNaoForamSelecionados = usuario => {
          const idsUsuariosSelecionados = this.usuariosSelecionados.map(usuario => usuario.id);

          const usuarioAindaNaoFoiSelecionado = !idsUsuariosSelecionados.includes(usuario.id);

          return usuarioAindaNaoFoiSelecionado;
        };
        
        const usuariosQueAindaNaoForamSelecionados = usuarios.filter(porUsuariosQueAindaNaoForamSelecionados);

        return usuariosQueAindaNaoForamSelecionados;
      },
      clientesDisponiveis(state) {
        return state.clientesDisponiveis;
      },
      imoveisDisponiveis(state) {
        return state.imoveisDisponiveis;
      }
    }),
    exibirCamposCaptados() {
      return this.relatorio.nome == "IMOVEIS_CAPTACAO_TIPO_IMOVEL";
    },
    exibirCamposVendidos() {
      return this.relatorio.nome == "IMOVEIS_VENDIDOS";
    },
    exibirCampoCliente() {
      return (
        this.relatorio.nome == "IMOVEIS_VENDIDOS" ||
        this.relatorio.nome == "IMOVEIS_POR_CLIENTE" || 
        this.relatorio.nome == "IMOVEIS_RESERVADOS"
      );
    },
    exibirCampoTipo() {
      return (
        this.relatorio.nome == "IMOVEIS_CAPTACAO_TIPO_IMOVEL" ||
        this.relatorio.nome == "IMOVEIS_COM_PLACA" ||
        this.relatorio.nome == "IMOVEIS_SEM_PLACA" ||
        this.relatorio.nome == "IMOVEIS_SEM_FOTO"
      );
    },
    exibirCampoCaptacao() {
      return (
        this.relatorio.nome == "IMOVEIS_SEM_PLACA" ||
        this.relatorio.nome == "IMOVEIS_SEM_FOTO"
      );
    },
    exibirCampoCorretor() {
      return (
        this.relatorio.nome == "VISITAS_POR_PERIODO" ||
        this.relatorio.nome == "IMOVEIS_RESERVADOS" ||
        this.relatorio.nome === 'IMOVEIS_FICHA'
      );
    },
    exibirCampoImovel() {
      return this.relatorio.nome == "OBSERVACOES_POR_PERIODO";
    },
    exibirFiltroDataPlaca(){
      return this.relatorio.nome === 'IMOVEIS_COM_PLACA';
    },
    exibirDataColocacaoPlaca(){
      return this.relatorio.nome === 'IMOVEIS_COM_PLACA';
    },
    exibirStatusPlaca(){
      return this.relatorio.nome === 'IMOVEIS_COM_PLACA';
    },
    opcoesStatusPlacas(){
      return [
        {label: "Instalada", data: "COLOCADA"},
        {label: "Retirada", data: "RETIRADA"},
        {label: "Extraviada", data: "EXTRAVIADA"}
      ];
    },
    exibirCampoPeriodo() {
      return (
        this.relatorio.nome == "IMOVEIS_CAPTACAO_TIPO_IMOVEL" ||
        this.relatorio.nome == "IMOVEIS_VENDIDOS" ||
        this.relatorio.nome == "OBSERVACOES_POR_PERIODO" ||
        this.relatorio.nome == "VISITAS_POR_PERIODO" ||
        this.relatorio.nome == "IMOVEIS_RESERVADOS" ||
        (this.relatorio.nome == "IMOVEIS_COM_PLACA" && this.relatorio.dataPlaca !== 'SEM_FILTRO') ||
        (this.relatorio.nome == "IMOVEIS_SEM_PLACA" && this.filtroDataCaptacao) ||
        (this.relatorio.nome == "IMOVEIS_SEM_FOTO" && this.filtroDataCaptacao)
      );
    },
    tiposImoveis() {
      return TIPOS_IMOVEIS;
    }
  },
  watch: {
    'relatorio.statusSelecionadosImovel': function(newValue){
      if(newValue.length === this.opcoesStatusImoveis.length){
        this.selecionarTodos = true;
      }else{
         this.selecionarTodos = false;
      }
    },
    'relatorio.statusSelecionadosPlaca': function(newValue){
      if(newValue.length === this.opcoesStatusPlacas.length){
        this.selecionarTodosPlacas = true;
      }else{
         this.selecionarTodosPlacas = false;
      }
    },
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("vendasRelatoriosStore", [
      "gerarRelatorio",
      "listarUsuarios",
      "listarClientes",
      "listarImoveis"
    ]),
    alterarStatusTodos(){
      if(this.selecionarTodos){
        this.relatorio.statusSelecionadosImovel = this.opcoesStatusImoveis.map(item => item.data);
      }else{
        this.relatorio.statusSelecionadosImovel = []
      }
    },
    alterarStatusTodosPlacas(){
      if(this.selecionarTodosPlacas){
        this.relatorio.statusSelecionadosPlaca = this.opcoesStatusPlacas.map(item => item.data);
      }else{
        this.relatorio.statusSelecionadosPlaca = [];
      }
    },
    gerar() {
      if(this.relatorio.nome === 'IMOVEIS_COM_PLACA') {
        if(this.relatorio.dataPlaca === 'CAPTACAO' || this.relatorio.dataPlaca === 'COLOCACAO' || this.relatorio.dataPlaca === 'RETIRADA') {
          const dataInicialNaoEValida = !funcoes.validarData(this.relatorio.dataInicial);
          const dataFinalNaoEValida = !funcoes.validarData(this.relatorio.dataFinal);

          if(dataInicialNaoEValida || dataFinalNaoEValida) {
            this.$message.warning('Selecione uma data válida');
            return;
          }
        }
        if(this.relatorio.statusSelecionadosPlaca && this.relatorio.statusSelecionadosPlaca.length === 0) {
          this.$message.warning('Selecione pelo menos um Status da Placa');
          return;
        }
      }

      const payload = Object.assign({}, this.relatorio);
      if(payload.nome === 'IMOVEIS_POR_CLIENTE') {
        if(!payload.cliente || payload.cliente.id === 0) {
          this.$message.warning('Selecione um Cliente');
          return;
        }
      }
      if (this.selecionarTodos) {
        delete payload.statusSelecionadosImovel;
      }
      if (this.usuariosSelecionados.length == 0) {
        delete payload.idsCorretores;
      }
      if (!this.filtroDataCaptacao && payload.nome !== 'IMOVEIS_COM_PLACA') {
        delete payload.dataInicial;
        delete payload.dataFinal;
      }

      if (payload.nome === 'IMOVEIS_COM_PLACA') {
        if (payload.dataPlaca === 'COLOCACAO') {
          payload.dataColocacaoInicial = payload.dataInicial;
          payload.dataColocacaoFinal = payload.dataFinal;
          delete payload.dataInicial;
          delete payload.dataFinal;
        } else if (payload.dataPlaca === 'RETIRADA') {
          payload.dataRemocaoInicial = payload.dataInicial;
          payload.dataRemocaoFinal = payload.dataFinal;
          delete payload.dataInicial;
          delete payload.dataFinal;
        } else if (payload.dataPlaca === 'SEM_FILTRO') {
          delete payload.dataInicial;
          delete payload.dataFinal;
        }

        if (this.selecionarTodosPlacas) {
          delete payload.statusSelecionadosPlaca;
        }
      }
      
      delete payload.dataPlaca;


      if(payload.nome != 'IMOVEIS_FICHA'){
        delete payload.modulo;
      }
    
      const idsUsuariosSelecionados = this.usuariosSelecionados.map(usuario => usuario.id);

      payload.idsCorretores = idsUsuariosSelecionados.join(', ');

      this.showLoading();
      this.gerarRelatorio(payload)
        .then(resultado => {
          this.hideLoading();
          if (resultado.status == "SUCESSO") {
            window.open(resultado.mensagem, "_blank");
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString };
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      });
    },
    filtrarClientesSelect(queryString) {
      let payload = {};

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

      this.loadingClientes = true;
      this.listarClientes(payload)
        .then(() => {
          this.loadingClientes = false;
        })
        .catch(() => {
          this.loadingUsuarios = false;
        });
    },
    filtrarImoveisSelect(queryString) {
      let payload = {
        operacao: "VENDA"
      };

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.endereco = queryString,

      this.loadingImoveis = true;
      this.listarImoveis(payload)
        .then(() => {
          this.loadingImoveis = false;
        })
        .catch(() => {
          this.loadingImoveis = false;
        });
    },
    adicionarUsuarioSelecionado() {
      if(this.auxUsuario === '' || this.auxUsuario.id === undefined) {
        return;
      }

      this.usuariosSelecionados.push(this.auxUsuario);
      this.auxUsuario = {};
    },
    removerUsuarioSelecionado(usuario) {
      var i;
      for (i = 0; i < this.usuariosSelecionados.length; i++) {
        if (this.usuariosSelecionados[i].id == usuario.id) {
          this.usuariosSelecionados.splice(i, 1);
        }
      }
    },
    formatarSelectCliente(cliente){
      return funcoes.formatarSelectCliente(cliente);
    },
    formatarEnderecoImovel(imovel) {
      let texto =
        "(" +
        imovel.idNaImobiliaria +
        ") " +
        (imovel.tipoImovel !== undefined
          ? imovel.tipoImovel.nome + " - "
          : "") +
        imovel.endereco;

      let numeroEndereco = imovel.numeroEndereco;
      if (numeroEndereco.length > 0) {
        texto += ", " + numeroEndereco;
      }

      let bairro = imovel.bairro.nome;
      if (bairro.length > 0) {
        texto += " (" + bairro + ")";
      }

      return texto;
    },
    fechar() {
      this.$emit("close");
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    limparImovelSelecionado() {
      this.relatorio.imovel = {
        operacao: "VENDA",
        tipoImovel: undefined
      }
      this.relatorio.modulo = 'VENDA',
      this.relatorio.statusSelecionadosImovel = [];
      this.relatorio.statusSelecionadosPlaca = ['COLOCADA'];
      this.relatorio.dataPlaca = 'CAPTACAO';
      this.selecionarTodos = false;
      this.selecionarTodosPlacas = false;
      this.relatorio.xls = false;
    }
  }
};
</script>

<style scoped>
.form-item {
  width: 100%;
}
.select {
  font-size: 50%;
}
</style>